import CommonUtils from '@/resources/utils/common-utils'
import API from '@/config/api'

const pageApi = {
  state: {

  },

  mutations: {
    getGroupList(state, data) {
      data.url = API.supplier.getGroupList
      CommonUtils.GetRequest(data)
    },
    addGroup(state, data) {
      data.url = API.supplier.addGroup
      CommonUtils.PostRequest(data)
    },
    editGroup(state, data) {
      data.url = API.supplier.editGroup
      CommonUtils.PostRequest(data)
    },
    getGroup(state, data) {
      data.url = API.supplier.getGroup
      CommonUtils.GetRequest(data)
    },
    getGroupSelectList(state, data) {
      data.url = API.supplier.getGroupSelectList
      CommonUtils.GetRequest(data)
    },
    getCompanyList(state, data) {
      data.url = API.supplier.getCompanyList
      CommonUtils.GetRequest(data)
    },
    addCompany(state, data) {
      data.url = API.supplier.addCompany
      CommonUtils.PostRequest(data)
    },
    getCompanyInfo(state, data) {
      data.url = API.supplier.getCompanyInfo
      CommonUtils.GetRequest(data)
    },
    updateCompany(state, data) {
      data.url = API.supplier.updateCompany
      CommonUtils.PostRequest(data)
    },
    getCompanySelectList(state, data) {
      data.url = API.supplier.getCompanySelectList
      CommonUtils.GetRequest(data)
    },
    getSupplierList(state, data) {
      data.url = API.supplier.getSupplierList
      CommonUtils.GetRequest(data)
    },
    addSupplier(state, data) {
      data.url = API.supplier.addSupplier
      CommonUtils.PostRequest(data)
    },
    editSupplier(state, data) {
      data.url = API.supplier.editSupplier
      CommonUtils.PostRequest(data)
    },
    getSupplierSelectList(state, data) {
      data.url = API.supplier.getSupplierSelectList
      CommonUtils.GetRequest(data)
    },
    delProductEvaluation(state, data) {
      data.url = API.supplier.delProductEvaluation
      CommonUtils.GetRequest(data)
    },
    getSupplierGoods(state, data) {
      data.url = API.supplier.getSupplierGoods
      CommonUtils.GetRequest(data)
    },
    checkCompanyAlias(state, data) {
      data.url = API.supplier.checkCompanyAlias
      CommonUtils.GetRequest(data)
    },
    // 设置理赔资料
    setClaimInformation(state, data) {
      data.url = API.supplier.setClaimInformation
      CommonUtils.PostRequest(data)
    },
    // 获取理赔渠道列表
    getClaimChannelList(state, data) {
      data.url = API.supplier.getClaimChannelList
      CommonUtils.GetRequest(data)
    },
    // 设置理赔指引详情
    setClaimRecordSteps(state, data) {
      data.url = API.supplier.setClaimRecordSteps;
      CommonUtils.PostRequest(data);
    },
    // 获取理赔指引详情
    getClaimRecordSteps(state, data) {
      data.url = API.supplier.getClaimRecordSteps;
      CommonUtils.GetRequest(data);
    },
    // 获取公司资料详情
    getCompanyClaimInformation(state, data) {
      data.url = API.supplier.getCompanyClaimInformation;
      CommonUtils.GetRequest(data);
    },
    delSupplierItem(state, data) {
      data.url = API.supplier.delSupplierItem;
      CommonUtils.GetRequest(data)
    }
  }
}

export default pageApi



// WEBPACK FOOTER //
// ./src/store/modules/supplier.js